module.exports = __webpack_public_path__ + "static/media/Twitter_Social_Icon_Square_White.b6b1f9ec.svg";